/** The part of Keycloak this needs: the login URL, without its navigation. */
export interface LoginRedirect {
  createLoginUrl(options?: { idpHint?: string }): Promise<string>;
}

export interface HistorySafeLocation {
  replace(url: string): void;
}

/** Sends the browser to Keycloak by replacing this history entry: `keycloak.login()` pushes one,
 *  and Back onto it re-enters sign-in, trapping users who came from the portal. */
export async function redirectToLogin(
  keycloak: LoginRedirect,
  idpHint: string | undefined,
  location: HistorySafeLocation,
): Promise<void> {
  location.replace(await keycloak.createLoginUrl({ idpHint }));
}
